import { Nullable } from '@rbi-ctg/frontend';
import { IStore } from '@rbi-ctg/store';
import { ServiceMode } from 'state/service-mode/types';
import {
  IPreloadedStoreState,
  IPreloadedStoreState2_0,
  Store,
  StoreState,
  initialStoreState
} from 'state/store/hooks';

/**
 * Helper function to initialize store for store selection 1.0
 *
 * @param {StoreState} preloaded Preloaded store
 * @param {Nullable<ServiceMode>} serviceMode Selected service mode
 */
export const initStore = (
  preloaded: IPreloadedStoreState,
  serviceMode: Nullable<ServiceMode>
): StoreState =>
  !!preloaded.store && serviceMode ? (preloaded.store as StoreState) : initialStoreState;

/**
 * Helper function to initialize store for store selection 2.0
 *
 * @param {Store} preloaded Preloaded store
 * @param {ServiceMode} serviceMode Selected service mode
 */
export const initStore2_0 = (
  preloaded: IPreloadedStoreState2_0 | null,
  serviceMode: Nullable<ServiceMode>
): Store => (preloaded && !!preloaded.store && serviceMode ? (preloaded.store as IStore) : null);
